// extracted by css-extract-rspack-plugin
export default {"container":"container--T_Jo1OYTJQKcDhN6","title":"title--CI9zarhOQoBs37wc","compensation":"compensation--KnA_JmzoHhkGBZlQ","company":"company--aie2Z22pgQiVDgp1"};